import axios from '../../axios'

export const postBase = ({groups}) => {
  return axios.post('/base', {groups})
}

export const getBase = () => {
  return axios.get('/base')
}



// WEBPACK FOOTER //
// ./src/api/production/questionsBase/index.js